import { Link } from 'react-router-dom';
import { GENRES, getMangasByGenre } from '@/mocks/manga';

export default function GenreNav() {
  return (
    <section id="categories" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <span className="text-sm font-semibold uppercase tracking-widest text-primary-600">Browse by Genre</span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              按类型快速找漫画
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              六大热门标签，想看的类型一目了然。点击进入对应分类，筛选排序随你掌控。
            </p>
          </div>
          <Link
            to="/category/rexue"
            className="whitespace-nowrap rounded-full border border-primary-300 px-5 py-2.5 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-100"
          >
            查看全部分类
            <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
          {GENRES.map((g) => {
            const count = getMangasByGenre(g.id).length;
            return (
              <Link
                key={g.id}
                to={`/category/${g.id}`}
                className="group flex flex-col items-center rounded-lg border border-background-200 bg-background-100 p-5 text-center transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 hover:bg-background-50"
              >
                <span className="flex h-14 w-14 items-center justify-center rounded-full bg-secondary-100 text-2xl text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={g.icon}></i>
                </span>
                <h3 className="mt-3 text-base font-bold text-foreground-900">{g.name}</h3>
                <p className="mt-1 line-clamp-2 text-xs text-foreground-600">{g.desc}</p>
                <span className="mt-3 rounded-full bg-accent-100 px-3 py-0.5 text-xs font-medium text-accent-800">
                  {count} 部作品
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}